module.exports = __webpack_public_path__ + "img/firma.e0f439df.gif";